import React from 'react';
import { gradeColor } from '../utils/gradeColor';
import {
  AssignedCard,
  AssignedCardName,
  AssignedCardChips,
  AssignedGradeChip,
} from '../styles/CustomerSpecsIndexStyles';

// Read-only mini-card for one Style / Label / Method entry on the Spec Index detail
// popup (Customer Specs detail-panel redesign, M3). The item name is the dominant
// line; its assigned grades render below as small secondary chips.
//
// `grades` is the SERVER-RESOLVED list ({value,grades} from GET /), already intersected
// against the spec's current grades by resolveAssignedGrades — never the raw CSV. Chip rule:
//   - no grades                          -> no chip (spec has zero grades, or an orphaned subset)
//   - covers all current grades          -> one grey "ALL" chip
//   - otherwise (a proper subset)        -> one colored chip per grade, in spec order
//
// `specGradeCount` is the DEDUPED count of the spec's grades (so a duplicate grade name
// cannot make a covers-all entry render as individual chips).
//
// When `onClick` is supplied the card becomes a button (Label/Method image lightbox);
// otherwise it is an inert div (Styles have no image).
export default function AssignedItemCard({ name, grades, specGradeCount, onClick, title }) {
  const list = Array.isArray(grades) ? grades : [];
  const clickable = typeof onClick === 'function';

  let chips = null;
  if (list.length === 0) {
    chips = null;
  } else if (specGradeCount > 0 && list.length === specGradeCount) {
    chips = <AssignedGradeChip $neutral>ALL</AssignedGradeChip>;
  } else {
    chips = list.map((g) => {
      const c = gradeColor(g);
      return (
        <AssignedGradeChip key={g} $bg={c.bg} $border={c.border}>{g}</AssignedGradeChip>
      );
    });
  }

  return (
    <AssignedCard
      as={clickable ? 'button' : 'div'}
      type={clickable ? 'button' : undefined}
      onClick={onClick}
      $clickable={clickable}
      title={title}
    >
      <AssignedCardName>{name}</AssignedCardName>
      {chips ? <AssignedCardChips>{chips}</AssignedCardChips> : null}
    </AssignedCard>
  );
}
